import _classCallCheck from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _defineProperty from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
import { URLBuilder } from "@azure/core-http";
import { BaseRequestPolicy } from "@azure/core-http";
import { delay } from "@azure/core-http";
/**
 * A set of constants used internally when processing requests.
 */

var Constants = {
  DefaultScope: "/.default",

  /**
   * Defines constants for use with HTTP headers.
   */
  HeaderConstants: {
    /**
     * The Authorization header.
     */
    AUTHORIZATION: "authorization"
  }
}; // Default options for the cycler if none are provided

var DEFAULT_CYCLER_OPTIONS = {
  forcedRefreshWindowInMs: 1000,
  retryIntervalInMs: 3000,
  refreshWindowInMs: 1000 * 60 * 2 // Start refreshing 2m before expiry

};
/**
 * Converts an an unreliable access token getter (which may resolve with null)
 * into an AccessTokenGetter by retrying the unreliable getter in a regular
 * interval.
 *
 * @param getAccessToken - a function that produces a promise of an access
 * token that may fail by returning null
 * @param retryIntervalInMs - the time (in milliseconds) to wait between retry
 * attempts
 * @param timeoutInMs - the timestamp after which the refresh attempt will fail,
 * throwing an exception
 * @returns - a promise that, if it resolves, will resolve with an access token
 */

function beginRefresh(_x, _x2, _x3) {
  return _beginRefresh.apply(this, arguments);
}
/**
 * Creates a token cycler from a credential, scopes, and optional settings.
 *
 * A token cycler represents a way to reliably retrieve a valid access token
 * from a TokenCredential. It will handle initializing the token, refreshing it
 * when it nears expiration, and synchronizes refresh attempts to avoid
 * concurrency hazards.
 *
 * @param credential - the underlying TokenCredential that provides the access
 * token
 * @param scopes - the scopes to request authorization for
 * @param tokenCyclerOptions - optionally override default settings for the cycler
 *
 * @returns - a function that reliably produces a valid access token
 */


function _beginRefresh() {
  _beginRefresh = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(getAccessToken, retryIntervalInMs, timeoutInMs) {
    var tryGetAccessToken, _tryGetAccessToken, token;

    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _tryGetAccessToken = function _tryGetAccessToken3() {
              _tryGetAccessToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
                var finalToken;
                return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        if (!(Date.now() < timeoutInMs)) {
                          _context3.next = 12;
                          break;
                        }

                        _context3.prev = 1;
                        _context3.next = 4;
                        return getAccessToken();

                      case 4:
                        return _context3.abrupt("return", _context3.sent);

                      case 7:
                        _context3.prev = 7;
                        _context3.t0 = _context3["catch"](1);
                        return _context3.abrupt("return", null);

                      case 10:
                        _context3.next = 18;
                        break;

                      case 12:
                        _context3.next = 14;
                        return getAccessToken();

                      case 14:
                        finalToken = _context3.sent;

                        if (!(finalToken === null)) {
                          _context3.next = 17;
                          break;
                        }

                        throw new Error("Failed to refresh access token.");

                      case 17:
                        return _context3.abrupt("return", finalToken);

                      case 18:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3, null, [[1, 7]]);
              }));
              return _tryGetAccessToken.apply(this, arguments);
            };

            tryGetAccessToken = function _tryGetAccessToken2() {
              return _tryGetAccessToken.apply(this, arguments);
            };

            _context4.next = 4;
            return tryGetAccessToken();

          case 4:
            token = _context4.sent;

          case 5:
            if (!(token === null)) {
              _context4.next = 13;
              break;
            }

            _context4.next = 8;
            return delay(retryIntervalInMs);

          case 8:
            _context4.next = 10;
            return tryGetAccessToken();

          case 10:
            token = _context4.sent;
            _context4.next = 5;
            break;

          case 13:
            return _context4.abrupt("return", token);

          case 14:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _beginRefresh.apply(this, arguments);
}

function createTokenCycler(credential, scopes, tokenCyclerOptions) {
  var refreshWorker = null;
  var token = null;
  var options = Object.assign(Object.assign({}, DEFAULT_CYCLER_OPTIONS), tokenCyclerOptions);
  /**
   * This little holder defines several predicates that we use to construct
   * the rules of refreshing the token.
   */

  var cycler = {
    /**
     * Produces true if a refresh job is currently in progress.
     */
    get isRefreshing() {
      return refreshWorker !== null;
    },

    /**
     * Produces true if the cycler SHOULD refresh (we are within the refresh
     * window and not already refreshing)
     */
    get shouldRefresh() {
      var _a;

      return !cycler.isRefreshing && ((_a = token === null || token === void 0 ? void 0 : token.expiresOnTimestamp) !== null && _a !== void 0 ? _a : 0) - options.refreshWindowInMs < Date.now();
    },

    /**
     * Produces true if the cycler MUST refresh (null or nearly-expired
     * token).
     */
    get mustRefresh() {
      return token === null || token.expiresOnTimestamp - options.forcedRefreshWindowInMs < Date.now();
    }

  };
  /**
   * Starts a refresh job or returns the existing job if one is already
   * running.
   */

  function refresh(getTokenOptions) {
    var _a;

    if (!cycler.isRefreshing) {
      // We bind `scopes` here to avoid passing it around a lot
      var tryGetAccessToken = function tryGetAccessToken() {
        return credential.getToken(scopes, getTokenOptions);
      }; // Take advantage of promise chaining to insert an assignment to `token`
      // before the refresh can be considered done.


      refreshWorker = beginRefresh(tryGetAccessToken, options.retryIntervalInMs, // If we don't have a token, then we should timeout immediately
      (_a = token === null || token === void 0 ? void 0 : token.expiresOnTimestamp) !== null && _a !== void 0 ? _a : Date.now()).then(function (_token) {
        refreshWorker = null;
        token = _token;
        return token;
      }).catch(function (reason) {
        // We also should reset the refresher if we enter a failed state.  All
        // existing awaiters will throw, but subsequent requests will start a
        // new retry chain.
        refreshWorker = null;
        token = null;
        throw reason;
      });
    }

    return refreshWorker;
  }

  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(tokenOptions) {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!cycler.mustRefresh) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return", refresh(tokenOptions));

            case 2:
              if (cycler.shouldRefresh) {
                refresh(tokenOptions);
              }

              return _context.abrupt("return", token);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x4) {
      return _ref.apply(this, arguments);
    };
  }();
}
/**
 * We will retrieve the challenge only if the response status code was 401,
 * and if the response contained the header "WWW-Authenticate" with a non-empty value.
 */


function getChallenge(response) {
  var challenge = response.headers.get("WWW-Authenticate");

  if (response.status === 401 && challenge) {
    return challenge;
  }

  return;
}
/**
 * Converts: `Bearer a="b" c="d"`.
 * Into: `[ { a: 'b', c: 'd' }]`.
 *
 * @internal
 */


function parseChallenge(challenge) {
  var bearerChallenge = challenge.slice("Bearer ".length);
  var challengeParts = "".concat(bearerChallenge.trim(), " ").split(" ").filter(function (x) {
    return x;
  });
  var keyValuePairs = challengeParts.map(function (keyValue) {
    return function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
          key = _ref3[0],
          value = _ref3[1];

      return _defineProperty({}, key, value);
    }(keyValue.trim().split("="));
  }); // Key-value pairs to plain object:

  return keyValuePairs.reduce(function (a, b) {
    return Object.assign(Object.assign({}, a), b);
  }, {});
} // #endregion

/**
 * Creates a new factory for a RequestPolicy that applies a bearer token to
 * the requests' `Authorization` headers.
 *
 * @param credential - The TokenCredential implementation that can supply the bearer token.
 * @param scopes - The scopes for which the bearer token applies.
 */


export function storageBearerTokenChallengeAuthenticationPolicy(credential, scopes) {
  // This simple function encapsulates the entire process of reliably retrieving the token
  var getToken = createTokenCycler(credential, scopes);

  var StorageBearerTokenChallengeAuthenticationPolicy = /*#__PURE__*/function (_BaseRequestPolicy) {
    _inherits(StorageBearerTokenChallengeAuthenticationPolicy, _BaseRequestPolicy);

    function StorageBearerTokenChallengeAuthenticationPolicy(nextPolicy, options) {
      _classCallCheck(this, StorageBearerTokenChallengeAuthenticationPolicy);

      return _possibleConstructorReturn(this, _getPrototypeOf(StorageBearerTokenChallengeAuthenticationPolicy).call(this, nextPolicy, options));
    }

    _createClass(StorageBearerTokenChallengeAuthenticationPolicy, [{
      key: "sendRequest",
      value: function () {
        var _sendRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(webResource) {
          var getTokenInternal, token, response, challenge, challengeInfo, challengeScopes, parsedAuthUri, pathSegments, tenantId, getTokenForChallenge, tokenForChallenge;
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (webResource.url.toLowerCase().startsWith("https://")) {
                    _context2.next = 2;
                    break;
                  }

                  throw new Error("Bearer token authentication is not permitted for non-TLS protected (non-https) URLs.");

                case 2:
                  getTokenInternal = getToken;
                  _context2.next = 5;
                  return getTokenInternal({
                    abortSignal: webResource.abortSignal,
                    tracingOptions: {
                      tracingContext: webResource.tracingContext
                    }
                  });

                case 5:
                  token = _context2.sent.token;
                  webResource.headers.set(Constants.HeaderConstants.AUTHORIZATION, "Bearer ".concat(token));
                  _context2.next = 9;
                  return this._nextPolicy.sendRequest(webResource);

                case 9:
                  response = _context2.sent;

                  if (!((response === null || response === void 0 ? void 0 : response.status) === 401)) {
                    _context2.next = 25;
                    break;
                  }

                  challenge = getChallenge(response);

                  if (!challenge) {
                    _context2.next = 25;
                    break;
                  }

                  challengeInfo = parseChallenge(challenge);
                  challengeScopes = challengeInfo.resource_id + Constants.DefaultScope;
                  parsedAuthUri = URLBuilder.parse(challengeInfo.authorization_uri);
                  pathSegments = parsedAuthUri.getPath().split("/");
                  tenantId = pathSegments[1];
                  getTokenForChallenge = createTokenCycler(credential, challengeScopes);
                  _context2.next = 21;
                  return getTokenForChallenge({
                    abortSignal: webResource.abortSignal,
                    tracingOptions: {
                      tracingContext: webResource.tracingContext
                    },
                    tenantId: tenantId
                  });

                case 21:
                  tokenForChallenge = _context2.sent.token;
                  getToken = getTokenForChallenge;
                  webResource.headers.set(Constants.HeaderConstants.AUTHORIZATION, "Bearer ".concat(tokenForChallenge));
                  return _context2.abrupt("return", this._nextPolicy.sendRequest(webResource));

                case 25:
                  return _context2.abrupt("return", response);

                case 26:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        }));

        function sendRequest(_x5) {
          return _sendRequest.apply(this, arguments);
        }

        return sendRequest;
      }()
    }]);

    return StorageBearerTokenChallengeAuthenticationPolicy;
  }(BaseRequestPolicy);

  return {
    create: function create(nextPolicy, options) {
      return new StorageBearerTokenChallengeAuthenticationPolicy(nextPolicy, options);
    }
  };
}